import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { createPolymorphicComponent } from '../../helpers/react/polymorphicComponentTypes';
import { DeterminateCircularProgressIndicator } from '../DeterminateCircularProgressIndicator';
import { IndeterminateCircularProgressIndicator } from '../IndeterminateCircularProgressIndicator';
export const CircularProgressIndicator = createPolymorphicComponent(forwardRef(function CircularProgressIndicator(props, forwardedRef) {
    const { value } = props;
    return value === undefined ? (_jsx(IndeterminateCircularProgressIndicator, { ...props, ref: forwardedRef })) : (_jsx(DeterminateCircularProgressIndicator, { ...props, ref: forwardedRef, value: value }));
}));
